import React from "react";

import connection from "../../../connection";
import GestaoCurso from "./gestao";
import VisualizacaoCurso from "./visualizacao";

import withStyles from "@material-ui/core/styles/withStyles";
import cursosStyle from "assets/jss/material-dashboard-pro-react/views/cursosStyle";

class PaginaCurso extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curso: null
    };
  }

  reloadInformacoesCurso = async () => {
    let id = this.props.id_curso || this.props.location.pathname.split("/curso/")[1];
    let curso = await connection.get("curso/detalhes", {curso_id: id});

    if (curso.formacao_continua)
      window.App.hist.push("/percurso/" + curso.percurso.id);

    this.setState({
      curso: curso,
      modal: null
    })
  };

  componentDidMount() {
    this.reloadInformacoesCurso();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let id = this.props.id_curso || this.props.location.pathname.split("/curso/")[1];
    let id_prev = prevProps.id_curso || prevProps.location.pathname.split("/curso/")[1];
    if (id_prev !== id) {
      this.reloadInformacoesCurso();
    }
  }

  render() {
    if (!this.state.curso)
      return "A carregar...";
    if (this.state.curso.pagina_gestao && !this.props.visualizacao)
      return <GestaoCurso detalhes={this.state.curso} reloadDetalhes={this.reloadInformacoesCurso}/>;
    return <VisualizacaoCurso detalhes={this.state.curso} reloadDetalhes={this.reloadInformacoesCurso}/>;
  }
}

export default withStyles(cursosStyle)(PaginaCurso);
